import {
  NEW_CONTRACTS,
  NEW_SINGLE_CONTRACT,
  NEW_SINGLE_CONTRACT_PORTAL,
  NEW_CONTRACTS_FILTERS,
  NEW_LOADING_TABLE,
  NEW_SEARCHING,
  NEW_STATS_CONTRACTS,
  NEW_VALUES_CONTRACTS,
  CHANGE_CONTRACT_SELECT,
  SET_CONTRACT_TO_EDIT,
  EARLY_CATALOG,
  NEW_EARLY_PAYMENT,
  UPDATE_EARLY_PAYMENT,
  DELETE_EARLY_PAYMENT,
  EARLY_BYID,
  EARLY_CONTRACT,
  EARLY_ALL,
  RESET_EARLY_BYID
} from '../actions/contractActions';

import { RESET_ACCOUNT, LOG_OUT } from '../actions/accountActions';

const initialState = {
  page: null,
  contract: null,
  portalContract: null,
  earlyPaymentCatalog: null,
  earlyPaymentByid: null,
  earlyPaymentContracts: null,
  earlyPaymentAll: null,
  activeFilters: [
    {
      label: 'Fecha contratos',
      filterKey: 'started_at',
      type: 'date',
      filterCondition: 'btw',
      value: '',
      period: 'Todo'
    },
    {
      label: 'Buscar',
      filterKey: 'general',
      type: 'search',
      value: '',
      personalized: true
    },
    {
      label: 'Página',
      filterKey: 'page',
      type: 'page',
      value: 1,
      personalized: true
    },
    {
      label: 'Tabs',
      filterKey: 'status',
      type: 'tab',
      value: 'active', // => 'Vigentes'
      personalized: true
    },
    {
      label: 'Estado',
      filterKey: 'status',
      type: 'options',
      options: [
        { label: 'Vigentes', value: 'active' },
        { label: 'Vencidos', value: 'inactive' },
        { label: 'Sin Fecha de Término', value: 'no_ended' }
      ],
      value: 'active,inactive,no_ended',
      personalized: true
    }
  ],
  updateTable: true,
  loadingTable: true,
  filters_stats: {},
  initialValuesTags: {
    Estado: {
      active: false,
      inactive: false,
      no_ended: false
    },
    Recurrencia: {
      monthly: false,
      weekly: false
    },
    Domiciliado: {
      0: false,
      1: false
    }
  },
  selected: [],
  contractToEdit: null
}; // END initialState

export default function (state = initialState, action) {
  let { payload, type } = action,
    newState;
  switch (type) {
    case NEW_CONTRACTS:
      newState = { page: payload };
      return { ...state, ...newState };

    case NEW_SINGLE_CONTRACT:
      newState = { contract: payload };
      return { ...state, ...newState };

    case NEW_SINGLE_CONTRACT_PORTAL:
      newState = { portalContract: payload };
      return { ...state, ...newState };

    case NEW_CONTRACTS_FILTERS:
      newState = { activeFilters: payload.filters, updateTable: payload.updateTable, searching: payload.searching };
      return { ...state, ...newState };

    case NEW_VALUES_CONTRACTS:
      newState = {
        initialValuesTags: payload
      };
      return { ...state, ...newState };

    case NEW_LOADING_TABLE:
      newState = { loadingTable: payload };
      return { ...state, ...newState };

    case NEW_SEARCHING:
      newState = { searching: payload };
      return { ...state, ...newState };

    case NEW_STATS_CONTRACTS:
      newState = { filters_stats: payload };
      return { ...state, ...newState };

    case RESET_ACCOUNT:
    case LOG_OUT:
      newState = { initialState };
      return { ...state, ...initialState };

    case CHANGE_CONTRACT_SELECT: {
      return {
        ...state,
        selected: action.payload.data
      };
    }
    case SET_CONTRACT_TO_EDIT: {
      return {
        ...state,
        contractToEdit: action.payload.data
      };
    }
    case EARLY_CATALOG: {
      return {
        ...state,
        earlyPaymentCatalog: action.payload.data
      };
    }
    case NEW_EARLY_PAYMENT: {
      return {
        ...state
      };
    }
    case UPDATE_EARLY_PAYMENT: {
      return {
        ...state
      };
    }
    case DELETE_EARLY_PAYMENT: {
      return {
        ...state
      };
    }
    case EARLY_BYID: {
      return {
        ...state,
        earlyPaymentByid: action.payload.data
      };
    }
    case EARLY_CONTRACT: {
      return {
        ...state,
        earlyPaymentContracts: action.payload.data
      };
    }
    case EARLY_ALL: {
      return {
        ...state,
        earlyPaymentAll: action.payload.data
      };
    }
    case RESET_EARLY_BYID: {
      return {
        ...state,
        earlyPaymentByid: action.payload
      };
    }

    default:
      return state;
  } // END switch
} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/contractReducer.js